/**
 * Add your action types here.
 * @module constants/ActionTypes
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const LOGINUNICO_AUTHORIZE_URI = 'LOGINUNICO_AUTHORIZE_URI';
export const LOGINUNICO_IS_ACTIVE = 'LOGINUNICO_IS_ACTIVE';
export const LOGINUNICO_LOGIN_FORM_ALLOWED = 'LOGINUNICO_LOGIN_FORM_ALLOWED';
export const LOGINUNICO_TOKEN = 'LOGINUNICO_TOKEN';
export const LOGINUNICO_LOGOUT = 'LOGINUNICO_LOGOUT';
export const LOGINUNICO_EXPIRES_GMT = 'LOGINUNICO_EXPIRES_GMT';
export const LOGINUNICO_RENEW_LOGIN = 'LOGINUNICO_RENEW_LOGIN_ENABLED';
export const LOGINUNICO_REDIRECT_AFTER_LOGIN = 'LOGINUNICO_REDIRECT_AFTER_LOGIN';